module.exports = __webpack_public_path__ + "static/media/stone-partner-logo.68a47204.png";